module.exports = __webpack_public_path__ + "static/img/44-3.5d8a223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/44-3.jpg
// module id = TZu0
// module chunks = 0